module.exports = __webpack_public_path__ + "static/media/covid-link.e02e04bf.svg";